import { render, staticRenderFns } from "./plandoctordentistlist.vue?vue&type=template&id=2f50ad75&scoped=true&"
import script from "./plandoctordentistlist.vue?vue&type=script&lang=js&"
export * from "./plandoctordentistlist.vue?vue&type=script&lang=js&"
import style0 from "./plandoctordentistlist.vue?vue&type=style&index=0&id=2f50ad75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f50ad75",
  null
  
)

export default component.exports